<template>
  <!-- @vue-ignore -->
  <q-input v-bind="$attrs">
    <template v-for="(slot, index) of slotNames" :key="index" #[slot]>
      <slot :name="slot" />
    </template>
  </q-input>
</template>

<script lang="ts" setup>
import { useSlots } from "vue";
const slots = useSlots();

// Assert type here to prevent errors in template
const slotNames = Object.keys(slots) as "default"[];
</script>
